<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Registrar visita</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <div class="col-md-6 col-sm-12 card-wrapper">
          <div class="card mb-4">
            <!-- Card header -->
            <div class="card-header">
              <h3 class="mb-0">{{ title }}</h3>
            </div>
            <!-- Card body -->
            <div class="card-body">
              <!-- Form groups used in grid -->
              <visit-form :schedule="schedule" :participants="participants" @save="saveVisit"></visit-form>
            </div>
          </div>
        </div>

        <div class="col-md-6 col-sm-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Participantes</h3>

              <div class="card-body">
                <participants-form
                  :participants="participants"
                  @add-participant="addParticipant"
                  @remove-participant="removeParticipant"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import swal from 'sweetalert2';
import VisitForm from './Form/VisitForm';
import ParticipantsForm from './Form/ParticipantsForm';

export default {
  name: 'VisitsCreate',
  components: {
    RouteBreadCrumb,
    VisitForm,
    ParticipantsForm,
  },

  data() {
    return {
      schedule: false,
      participants: [],
      title: 'Agregar una nueva visita',
    };
  },

  created() {
    if (this.$route.meta.hasOwnProperty('resource')) {
      if (this.$can('show', this.$route.meta.resource)) {
        this.$services
          .resource(this.$route.meta.resource)
          .show(this.$route.params.id)
          .then((res) => res.data.data)
          .then((data) => {
            const name = data.name || data.businessName;
            this.participants.push({
              id: data.id,
              name: name,
              type: this.$route.meta.resource,
              typeToShow: this.$route.meta.typeToShow,
              principal: true,
            });
            this.title = `Crear una visita para ${name}`;
          });
      }
    }

    if (this.$route.query.hasOwnProperty('schedule')) {
      this.schedule = JSON.parse(this.$route.query.schedule);
    }
  },

  methods: {
    addParticipant(participant) {
      this.participants.push(participant);
    },

    removeParticipant(index) {
      this.participants.splice(index, 1);
    },

    saveVisit(visit) {
      visit.participants = this.participants;
      this.$services
        .resource('visits')
        .create(visit)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'La visita fue registrada.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'VisitsList' }));
        });
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
